<div class="frame-banner">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <ng-container >
        <ul cdkDropList [style.height]="objectChoosing.objects.length <= 5?'auto': '300px'"
          [style.min-height]="objectChoosing.objects.length <= 5?'auto': '300px'" class="example-list"
          (cdkDropListDropped)="cdkDropListDropped($event)">
          <li class="example-box row m-0"
            *ngFor="let frame of objectChoosing.objects; index as i" cdkDrag>
            <div class="col p-0 d-flex align-items-center">
              <i class="bi bi-list example-handle mr-1" cdkDragHandle></i>
              <span (click)="selectSlide(i)" class="p-0 m-0" data-toggle="tooltip" [title]="frame.name"
                > {{ frame.name.length >= 18 ?
                (frame.name | slice:0:15) + '...' : frame.name }}</span>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
  </ng-container>

  
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced' ">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- THÀNH PHẦN  -->
      <li nz-submenu nzTitle="{{'thanh_phan' | translate}}" [(nzOpen)]="openMenu.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="main">
          <div>
            <div class="example_btn">
              <button class="_btn d-flex justify-content-between align-items-center p-1" (click)="addSlide()">
                <span>{{'them_khung_moi' | translate}}</span> <span class="ml-1" nz-icon nzType="plus-circle"
                  nzTheme="outline"></span></button>
            </div>
            <ng-container >
              <ul cdkDropList [style.height]="objectChoosing.objects.length <= 5?'auto': '300px'"
                [style.min-height]="objectChoosing.objects.length <= 5?'auto': '300px'" class="example-list"
                (cdkDropListDropped)="cdkDropListDropped($event)">
                <li class="example-box row m-0"
                  *ngFor="let frame of objectChoosing.objects; index as i" cdkDrag>
                  <div class="col p-0 d-flex align-items-center">
                    <i class="bi bi-list example-handle mr-1" cdkDragHandle></i>
                    <span (click)="selectSlide(i)" class="p-0 m-0" data-toggle="tooltip" [title]="frame.name"
                      > {{ frame.name.length >= 18 ?
                      (frame.name | slice:0:15) + '...' : frame.name }}</span>
                  </div>
                  <div class="colp-0">
                    <span nz-icon nzType="dash" nzTheme="outline" class="_icon_option"
                      (click)="$event.stopPropagation();onContextMenu($event, menuObjectBlockFooter)"></span>
                  </div>
                  <nz-dropdown-menu #menuObjectBlockFooter="nzDropdownMenu">
                    <ul nz-menu [nzMode]="'vertical'">
                      <li nz-menu-item class="text-success" (click)="$event.stopPropagation(); editNameItem(frame)">
                        <i class="bi bi-pencil-square mr-2"></i>
                        {{'sua_ten_khung' | translate}}
                      </li>
                      <li nz-menu-item *ngIf="config['slick_dot_label']?.['is_label_for_dot']"
                      class="text-success" (click)="$event.stopPropagation(); editLabelItem(frame)">
                        <i class="bi bi-pencil-square mr-2"></i>
                        {{'sua_tieu_de_khung' | translate}}
                      </li>
                      <li nz-menu-item class="text-danger" (click)="$event.stopPropagation(); deleteItem(frame)"><i
                          class="bi bi-trash mr-2"></i>
                        {{'xoa_khung' | translate}}</li>
                    </ul>
                  </nz-dropdown-menu>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
      </li>
      <!-- HIỆU ỨNG  -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMenu.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="editor-field">
          <!-- Tự động chuyển -->
          <div class="config-name mt-0">
            <p>{{'tu_dong_chuyen' | translate}}</p>
            <nz-switch [ngModel]="config['frame-banner']['is_autoplay']"
              (ngModelChange)="config['frame-banner']['is_autoplay'] = !config['frame-banner']['is_autoplay']; updateConfig()"></nz-switch>
          </div>
          <!-- Cuộn chuột chuyển slide -->
          <div *ngIf="device == 'desktop'" class="config-name mt-0">
            <p>{{'cuon_chuot_chuyen_slide' | translate}}</p>
            <nz-switch [ngModel]="config['frame-banner']['is_scroll_switch_slides']"
              (ngModelChange)="config['frame-banner']['is_scroll_switch_slides'] = $event; updateConfig()"></nz-switch>
          </div>
          <div>
            <div *ngIf="config['frame-banner']['is_autoplay']">
              <div class="config-name mb-0">
                <p>{{'thoi_gian_cho' | translate}} (s)</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [(ngModel)]="config['frame-banner']['time_auto_play']"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [(ngModel)]="config['frame-banner']['time_auto_play']"
                  (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
            <div>
              <div class="config-name mt-3 mb-0">
                <p>{{'thoi_gian_chuyen' | translate}} (s)</p>
                <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [(ngModel)]="config['frame-banner']['time_animation_play']"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [(ngModel)]="config['frame-banner']['time_animation_play']"
                  (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
            <div class="mt-4 mb-2">
              <p class="mb-3">{{'kieu_hieu_ung' | translate}}</p>
              <nz-select
                [(ngModel)]="config['frame-banner']['slide_transition_animation']"
                (ngModelChange)="updateConfig()">
                <nz-option *ngFor="let item of slideTransitionAnimation" [nzValue]="item.value"
                  [nzLabel]="item.label | translate"></nz-option>
              </nz-select>
            </div>
          </div>
        </div>
      </li>
      <!-- ĐƯỜNG VIỀN CHUNG -->
      <li nz-submenu nzTitle="{{'duong_vien_chung' | translate}}" [(nzOpen)]="openMenu.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device"
                            [class]="class"
                            [borderClass]="class['frame-banner']"
                            [id_object]="objectChoosing._id"
                            [elementChoosing]="objectChoosing"
        >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- CẤU HÌNH NÚT PREV -->
      <li nz-submenu nzTitle="{{'cau_hinh_nut_prev' | translate}}" [(nzOpen)]="openMenu.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="editor-field">
          <!-- Chọn icon -->
          <div class="config-name mt-0">
            <p>{{'chon_icon' | translate}}</p>
            <button style="width:40%;border-radius:5px" (click)="chooseIcon('prev')">
              <mat-icon>{{config['frame-banner__btn--prev']['icon_name']}}</mat-icon>
            </button>
          </div>
          <!-- Màu icon -->
          <div class="config-name">
            <p>{{'mau_icon' | translate}}</p>
            <input class="input-color"  type="button"
              [style.background]="class['frame-banner__icon--prev']['color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-banner__icon--prev']['color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <!-- Kích thước icon -->
          <div>
            <div class="config-name">
              <p>{{'kich_thuoc_icon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-banner__icon--prev']['font-size'] | vhnumber"
                (ngModelChange)="handleSetIconFontSize($event, 'prev')">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-banner__icon--prev']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-banner__icon--prev']['font-size'] = $event+'px'"
                (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Cách trái -->
          <div class="title">
            <div class="config-name">
              <p>{{'cach_trai' | translate}} (%)</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-banner__btn--prev']['left'] | vhnumber"
                (ngModelChange)="class['frame-banner__btn--prev']['left'] = $event+'%'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--prev']['left'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--prev']['left'] = $event+'%'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Cách trên -->
          <div>
            <div class="config-name">
              <p>{{'cach_tren' | translate}} (%)</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-banner__btn--prev']['top'] | vhnumber"
                (ngModelChange)="class['frame-banner__btn--prev']['top'] = $event+'%'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--prev']['top'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--prev']['top'] = $event+'%'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[2])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- CẤU HÌNH NÚT NEXT -->
      <li nz-submenu nzTitle="{{'cau_hinh_nut_next' | translate}}" [(nzOpen)]="openMenu.menu6" (nzOpenChange)="openHandler('menu6')">
        <div class="editor-field">
          <!-- Chọn icon -->
          <div class="config-name mt-0">
            <p>{{'chon_icon' | translate}}</p>
            <button style="width:40%;border-radius:5px" (click)="chooseIcon('next')">
              <mat-icon>{{config['frame-banner__btn--next']['icon_name']}}</mat-icon>
            </button>
          </div>
          <!-- Màu icon -->
          <div class="config-name">
            <p>{{'mau_icon' | translate}}</p>
            <input class="input-color"  type="button"
              [style.background]="class['frame-banner__icon--next']['color']"
              [cpOKButton]="true" [(colorPicker)]="class['frame-banner__icon--next']['color']"
              (colorPickerClose)="updateClass()" />
          </div>
          <!-- Kích thước icon -->
          <div>
            <div class="config-name">
              <p>{{'kich_thuoc_icon' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-banner__icon--next']['font-size'] | vhnumber"
                (ngModelChange)="handleSetIconFontSize($event, 'next')">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                [ngModel]="class['frame-banner__icon--next']['font-size'] | vhnumber"
                (ngModelChange)="class['frame-banner__icon--next']['font-size'] = $event+'px'"
                (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Cách phải -->
          <div class="title">
            <div class="config-name">
              <p>{{'cach_phai' | translate}} (%)</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-banner__btn--next']['right'] | vhnumber"
                (ngModelChange)="class['frame-banner__btn--next']['right'] = $event+'%'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--next']['right'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--next']['right'] = $event+'%'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Cách trên -->
          <div>
            <div class="config-name">
              <p>{{'cach_tren' | translate}} (%)</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['frame-banner__btn--next']['top'] | vhnumber"
                (ngModelChange)="class['frame-banner__btn--next']['top'] = $event+'%'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--next']['top'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--next']['top'] = $event+'%'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
          <!-- Nút mở rộng -->
          <div class="config-name view-more-btn">
            <p (click)="openViewAll(stylesField[3])">{{'mo_rong' | translate}} &#8594;</p>
          </div>
        </div>
      </li>
      <!-- CẤU HÌNH NÚT PHÂN TRANG -->
      <li nz-submenu nzTitle="{{'cau_hinh_nut_phan_trang' | translate}}" [(nzOpen)]="openMenu.menu7" (nzOpenChange)="openHandler('menu7')">
        <div class="editor-field">
          <!-- Cấu hình chung -->
          <div nz-submenu nzTitle="{{'cau_hinh_chung' | translate}}" [(nzOpen)]="openMenu.menu8">
            <div class="editor-field">
              <!-- Kiểu nút slide -->
              <div class="config-row mt-2">
                <p class="mb-3">{{'kieu_nut_slide' | translate}}</p>
                <nz-radio-group
                  [(ngModel)]="config['slick-dots']['background_style']"
                  (ngModelChange)="handleSetDotsStyle($event)">
                  <label nz-radio nzValue="circle">{{'hinh_tron' | translate}}</label>
                  <label nz-radio nzValue="square">{{'hinh_vuong' | translate}}</label>
                  <label nz-radio nzValue="rectangle">{{'hinh_chu_nhat' | translate}}</label>
                </nz-radio-group>
              </div>
              <!-- Bo góc -->
              <div *ngIf="config['slick-dots']['background_style'] != 'circle'">
                <div class="config-name">
                  <p>{{'bo_goc' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="50"
                    [ngModel]="class['frame-banner__slick-dot']['border-radius'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot']['border-radius'] = $event +'px'; class['frame-banner__slick-dot--active']['border-radius'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                  [ngModel]="class['frame-banner__slick-dot']['border-radius'] | vhnumber"
                  (ngModelChange)="class['frame-banner__slick-dot']['border-radius'] = $event+'px'; class['frame-banner__slick-dot--active']['border-radius'] = $event+'px'"
                  (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <hr style="border-top: 1px solid rgb(223 223 223)" />
              <!-- Cuộn chuột chuyển slide -->
              <div class="config-name mt-0">
                <p>{{'so_thu_tu_slide' | translate}}</p>
                <nz-switch [ngModel]="config['frame-banner']['is_slide_number']"
                  (ngModelChange)="config['frame-banner']['is_slide_number'] = $event; updateConfig()"></nz-switch>
              </div>
              <ng-container *ngIf="config['frame-banner']['is_slide_number']">
                <!-- Loại số thứ tự slide -->
                <div class="config-row">
                  <p class="mb-3">{{'loai_so_thu_tu_slide' | translate}}</p>
                  <nz-radio-group [ngModel]="config['frame-banner']['slide_number_type']"
                    (ngModelChange)="config['frame-banner']['slide_number_type'] = $event; updateConfig()">
                    <label nz-radio nzValue="0">{{'so_don' | translate}}</label>
                    <label nz-radio nzValue="00">{{'so_doi' | translate}}</label>
                  </nz-radio-group>
                </div>
              </ng-container>
              <hr style="border-top: 1px solid rgb(223 223 223)" />
              <div class="config-name">
                <p>{{'nhan_nut_slide' | translate}}</p>
                <nz-switch [ngModel]="config['slick_dot_label']?.['is_label_for_dot']"
                  (ngModelChange)="config['slick_dot_label']['is_label_for_dot'] = $event; updateConfig()">
                </nz-switch>
              </div>
              <hr style="border-top: 1px solid rgb(223 223 223)" />
              <!-- Vị trí cụm nút -->
              <div class="config-row">
                <p class="mb-3">{{'vi_tri_cum_nut' | translate}}</p>
                <nz-radio-group
                  [(ngModel)]="config['frame-banner']['dots_position']"
                  (ngModelChange)="handleSetDotsPosition($event)">
                  <label nz-radio nzValue="left">{{'trai' | translate}}</label>
                  <label nz-radio nzValue="right">{{'phai' | translate}}</label>
                  <label nz-radio nzValue="top">{{'tren' | translate}}</label>
                  <label nz-radio nzValue="bottom">{{'duoi' | translate}}</label>
                </nz-radio-group>
              </div>
              <!-- Canh cụm nút -->
              <div class="config-row">
                <p class="mb-3">{{'canh_cum_nut' | translate}}</p>
                <nz-radio-group
                  [ngModel]="
                    ['top', 'bottom'].includes(config['frame-banner']['dots_position'])
                    ? class['frame-banner__slick-dots-wrapper']['justify-content']
                    : class['frame-banner__slick-dots-wrapper']['align-items']
                  "
                  (ngModelChange)="handleSetDotsAlign($event)">
                  <label nz-radio nzValue="center">{{'canh_giua' | translate}}</label>
                  <label nz-radio nzValue="flex-start">
                    {{(['top', 'bottom'].includes(config['frame-banner']['dots_position']) ? 'canh_le_trai' : 'canh_le_tren') | translate}}
                  </label>
                  <label nz-radio nzValue="flex-end">
                    {{(['top', 'bottom'].includes(config['frame-banner']['dots_position']) ? 'canh_le_phai' : 'canh_le_duoi') | translate}}
                  </label>
                </nz-radio-group>
              </div>
              <!-- Khoảng cách các nút -->
              <div>
                <div class="config-name">
                  <p>{{'khoang_cach_cac_nut' | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dots']['gap'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dots']['gap'] = $event+'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dots']['gap'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dots']['gap'] = $event+'px'"
                    (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <!-- Khoảng cách bên dưới -->
              <div>
                <div class="config-name">
                  <p>{{('khoang_cach_ben_' + positionMap[config['frame-banner']['dots_position']]) | translate}}</p>
                  <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dots-wrapper'][config['frame-banner']['dots_position']] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dots-wrapper'][config['frame-banner']['dots_position']] = $event + 'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dots-wrapper'][config['frame-banner']['dots_position']] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dots-wrapper'][config['frame-banner']['dots_position']] = $event + 'px'"
                    (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <ng-container *ngIf="['top', 'bottom'].includes(config['frame-banner']['dots_position'])">
                <!-- Khoảng cách bên trái -->
                <div *ngIf="class['frame-banner__slick-dots-wrapper']['justify-content'] == 'flex-start'">
                  <div class="config-name">
                    <p>{{'khoang_cach_ben_trai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-left'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-left'] = $event + 'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-left'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-left'] = $event + 'px'"
                      (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Khoảng cách bên phải -->
                <div *ngIf="class['frame-banner__slick-dots-wrapper']['justify-content'] == 'flex-end'">
                  <div class="config-name">
                    <p>{{'khoang_cach_ben_phai' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-right'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-right'] = $event + 'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-right'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-right'] = $event + 'px'"
                      (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </ng-container>
              <ng-container *ngIf="['left', 'right'].includes(config['frame-banner']['dots_position'])">
                <!-- Khoảng cách bên trái -->
                <div *ngIf="class['frame-banner__slick-dots-wrapper']['align-items'] == 'flex-start'">
                  <div class="config-name">
                    <p>{{'khoang_cach_ben_tren' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-top'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-top'] = $event + 'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-top'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-top'] = $event + 'px'"
                      (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
                <!-- Khoảng cách bên phải -->
                <div *ngIf="class['frame-banner__slick-dots-wrapper']['align-items'] == 'flex-end'">
                  <div class="config-name">
                    <p>{{'khoang_cach_ben_duoi' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-bottom'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-bottom'] = $event + 'px'"
                      (nzBlur)="updateClass()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
                      [ngModel]="class['frame-banner__slick-dots-wrapper']['padding-bottom'] | vhnumber"
                      (ngModelChange)="class['frame-banner__slick-dots-wrapper']['padding-bottom'] = $event + 'px'"
                      (nzOnAfterChange)="updateClass()">
                  </nz-slider>
                </div>
              </ng-container>
            </div>
          </div>
          <!-- Thiết lập Số slide -->
          <div nz-submenu nzTitle="{{'thiet_lap_so_slide' | translate}}" [(nzOpen)]="openMenu.menu9">
            <div class="editor-field mb-0">
              <div class="config-name">
                <p>{{'su_dung' | translate}}</p>
                <nz-switch [(ngModel)]="config['frame-banner__show-banner--number-text']['display_check']"
                  (ngModelChange)="updateConfig()">
                </nz-switch>
              </div>
              <div *ngIf="config['frame-banner__show-banner--number-text']['display_check']">
                <div class="field-row mt-0">
                  <div class="config-font-size">
                    <!-- Font Family -->
                    <div class="field-row-font" style="width:65%">
                      <mat-form-field style="width:100%">
                        <mat-label>Font</mat-label>
                        <mat-select
                          [(ngModel)]="class['frame-banner__show-banner--number-text-content']['font-family']"
                          (ngModelChange)="updateClass()">
                          <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <!-- Font size -->
                    <div class="field-row-size" style="width:35%;padding-right:5px">
                      <mat-form-field style="width:100%">
                        <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                        <input matInput type="number" min="1" max="200"
                          [ngModel]="class['frame-banner__show-banner--number-text-content']['font-size'] | vhnumber"
                          (ngModelChange)="class['frame-banner__show-banner--number-text-content']['font-size'] = $event+'px'"
                          (blur)="updateClass()">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="field-row">
                  <div class="config-font">
                    <p class="title">{{'kieu_chu' | translate}}</p>
                    <div class="config-name">
                      <!-- In đậm -->
                      <button class="font-text-btn" title="Bold" nz-button [nzType]="
                        class['frame-banner__show-banner--number-text-content']['font-weight'] >= 700
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__show-banner--number-text-content']['font-weight'] =
                            class['frame-banner__show-banner--number-text-content']['font-weight'] >= 700
                              ? '400'
                              : '700'
                        "(click)="updateClass();">
                        <span style="font-weight:600;">B</span>
                      </button>
                      <!-- In nghiêng -->
                      <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class['frame-banner__show-banner--number-text-content']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__show-banner--number-text-content']['font-style'] =
                            class['frame-banner__show-banner--number-text-content']['font-style'] == 'normal'
                              ? 'italic'
                              : 'normal'
                        "(click)="updateClass();">
                        <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Gạch dưới -->
                      <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class['frame-banner__show-banner--number-text-content']['text-decoration'] == 'underline'
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__show-banner--number-text-content']['text-decoration'] =
                            class['frame-banner__show-banner--number-text-content']['text-decoration'] == 'none'
                              ? 'underline'
                              : 'none'
                        "(click)="updateClass();">
                        <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Màu chữ -->
                      <input class="input-color" style="width:22%;"  type="button"
                        [style.background]="class['frame-banner__show-banner--number-text-content']['color']"
                        [cpOKButton]="true" [(colorPicker)]="class['frame-banner__show-banner--number-text-content']['color']"
                        (colorPickerClose)="updateClass()" />
                    </div>
                    <!-- Độ đậm -->
                    <div class="my-3 mt-4">
                      <div class="config-name mb-0">
                        <p>{{'do_dam' | translate}}</p>
                        <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                          [(ngModel)]="class['frame-banner__show-banner--number-text-content']['font-weight']"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-row>
                        <nz-col nzSpan="24">
                          <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                            [(ngModel)]="class['frame-banner__show-banner--number-text-content']['font-weight']"
                            (nzOnAfterChange)="updateClass()">
                          </nz-slider>
                        </nz-col>
                      </nz-row>
                    </div>
                    <!-- Canh lề -->
                    <div class="config-font">
                      <p class="title">{{'canh_le' | translate}}</p>
                      <div class="config-name">
                        <button class="font-text-btn" nz-button
                          [nzType]="
                            class['frame-banner__show-banner--number-text-content']['right'] == 'auto'
                              && class['frame-banner__show-banner--number-text-content']['transform'] == 'translateX(0)'
                                ? 'primary'
                                : 'default'"
                          (click)="handleSetNumberTextContent('left')">
                          <i nz-icon nzType="align-left" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button 
                          [nzType]="
                            class['frame-banner__show-banner--number-text-content']['left'] == '50%'
                              ? 'primary'
                              : 'default'"
                          (click)="handleSetNumberTextContent('center')">
                          <i nz-icon nzType="align-center" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button 
                          [nzType]="
                            class['frame-banner__show-banner--number-text-content']['left'] == 'auto'
                              ? 'primary'
                              : 'default'"
                          (click)="handleSetNumberTextContent('right')">
                          <i nz-icon nzType="align-right" nzTheme="outline"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field-row">
                  <div class="config-font" style="margin-top:20px">
                    <!-- Khoảng cách chữ -->
                    <div>
                      <div class="config-name mb-0">
                        <p>{{ 'khoang_cach_chu' | translate }}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="50"
                          [ngModel]="class['frame-banner__show-banner--number-text-content']['letter-spacing'] | vhnumber"
                          (ngModelChange)="class['frame-banner__show-banner--number-text-content']['letter-spacing'] = $event+'px'"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-row>
                        <nz-col nzSpan="24">
                          <nz-slider [nzMin]="0" [nzMax]="50"
                            [ngModel]="class['frame-banner__show-banner--number-text-content']['letter-spacing'] | vhnumber"
                            (ngModelChange)="class['frame-banner__show-banner--number-text-content']['letter-spacing'] = $event+'px'"
                            (nzOnAfterChange)="updateClass()">
                          </nz-slider>
                        </nz-col>
                      </nz-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="config['slick_dot_label']?.['is_label_for_dot']">
            <div nz-submenu nzTitle="{{'thiet_lap_nhan_slide_chua_chon' | translate}}" [(nzOpen)]="openMenu.menu12">
              <div class="editor-field mb-0">
                <!-- Màu nền -->
                <div class="config-name">
                  <p>{{'mau_nen' | translate}}</p>
                  <input class="input-color" style="width:22%;"  type="button"
                    [style.background]="class['frame-banner__slick-dot__label']['background-color']"
                    [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot__label']['background-color']"
                    (colorPickerClose)="updateClass()" />
                </div>
                <!-- Vị trí nhãn khi di chuột -->
                <div *ngIf="device == 'desktop'">
                  <div class="config-name">
                    <p>{{'vi_tri_nhan_khi_di_chuot' | translate}}</p>
                    <nz-input-number [nzMin]="-200" [nzMax]="200" style="width: 30%"
                      [ngModel]="config['slick_dot_label']['hover_label_translateX'] | vhnumber"
                      (ngModelChange)="config['slick_dot_label']['hover_label_translateX'] = $event +'px'"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="-200" [nzMax]="200" [nzStep]="1"
                    [ngModel]="config['slick_dot_label']['hover_label_translateX'] | vhnumber"
                    (ngModelChange)="config['slick_dot_label']['hover_label_translateX'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>
                <ul nz-menu nzMode="inline">
                  <div nz-submenu nzTitle="{{'kich_thuoc_nhan' | translate}}">
                    <!-- Chiều rộng -->
                    <div>
                      <div class="config-name">
                        <p>{{'chieu_rong' | translate}}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="300"
                          [ngModel]="class['frame-banner__slick-dot__label']['width'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot__label']['width'] = $event +'px'"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-slider [nzMin]="0" [nzMax]="300" [nzStep]="1"
                        [ngModel]="class['frame-banner__slick-dot__label']['width'] | vhnumber"
                        (ngModelChange)="class['frame-banner__slick-dot__label']['width'] = $event+'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </div>
                    <!-- Chiều cao -->
                    <div>
                      <div class="config-name">
                        <p>{{'chieu_cao' | translate}}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="300"
                          [ngModel]="class['frame-banner__slick-dot__label']['height'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot__label']['height'] = $event +'px'"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-slider [nzMin]="0" [nzMax]="300" [nzStep]="1"
                        [ngModel]="class['frame-banner__slick-dot__label']['height'] | vhnumber"
                        (ngModelChange)="class['frame-banner__slick-dot__label']['height'] = $event+'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </div>
                  </div>
                  <div nz-submenu nzTitle="{{'vien' | translate}}">
                    <app-borders-config
                      [elementChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [borderClass]="class['frame-banner__slick-dot__label']"
                      [id_object]="objectChoosing._id"
                    >
                    </app-borders-config>
                    <!-- Bo góc -->
                    <app-borders-radius-config
                      [elementChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [borderRadiusClass]="class['frame-banner__slick-dot__label']"
                      [id_object]="objectChoosing._id"
                    >
                    </app-borders-radius-config>
                  </div>
                  <div nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}">
                    <div class="field-row mt-0">
                      <div class="config-font-size">
                        <!-- Font Family -->
                        <div class="field-row-font" style="width:65%">
                          <mat-form-field style="width:100%">
                            <mat-label>Font</mat-label>
                            <mat-select
                              [(ngModel)]="class['frame-banner__slick-dot__label']['font-family']"
                              (ngModelChange)="updateClass()">
                              <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Font size -->
                        <div class="field-row-size" style="width:35%;padding-right:5px">
                          <mat-form-field style="width:100%">
                            <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                            <input matInput type="number" min="1" max="200"
                              [ngModel]="class['frame-banner__slick-dot__label']['font-size'] | vhnumber"
                              (ngModelChange)="class['frame-banner__slick-dot__label']['font-size'] = $event+'px'"
                              (blur)="updateClass()">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                    <div class="field-row">
                      <div class="config-font">
                        <p class="title">{{'kieu_chu' | translate}}</p>
                        <div class="config-name">
                          <!-- In đậm -->
                          <button class="font-text-btn" title="Bold" nz-button [nzType]="
                            class['frame-banner__slick-dot__label']['font-weight'] >= 700
                              ? 'primary'
                              : 'default'
                            "(click)="
                              class['frame-banner__slick-dot__label']['font-weight'] =
                                class['frame-banner__slick-dot__label']['font-weight'] >= 700
                                  ? '400'
                                  : '700'
                            "(click)="updateClass();">
                            <span style="font-weight:600;">B</span>
                          </button>
                          <!-- In nghiêng -->
                          <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                            class['frame-banner__slick-dot__label']['font-style'] == 'italic'
                              ? 'primary'
                              : 'default'
                            "(click)="
                              class['frame-banner__slick-dot__label']['font-style'] =
                                class['frame-banner__slick-dot__label']['font-style'] == 'normal'
                                  ? 'italic'
                                  : 'normal'
                            "(click)="updateClass();">
                            <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                          </button>
                          <!-- Gạch dưới -->
                          <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                            class['frame-banner__slick-dot__label']['text-decoration'] == 'underline'
                              ? 'primary'
                              : 'default'
                            "(click)="
                              class['frame-banner__slick-dot__label']['text-decoration'] =
                                class['frame-banner__slick-dot__label']['text-decoration'] == 'none'
                                  ? 'underline'
                                  : 'none'
                            "(click)="updateClass();">
                            <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                          </button>
                          <!-- Màu chữ -->
                          <input class="input-color" style="width:22%;"  type="button"
                            [style.background]="class['frame-banner__slick-dot__label']['color']"
                            [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot__label']['color']"
                            (colorPickerClose)="updateClass()" />
                        </div>
                        <!-- Độ đậm -->
                        <div class="my-3 mt-4">
                          <div class="config-name mb-0">
                            <p>{{'do_dam' | translate}}</p>
                            <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                              [(ngModel)]="class['frame-banner__slick-dot__label']['font-weight']"
                              (nzBlur)="updateClass()">
                            </nz-input-number>
                          </div>
                          <nz-row>
                            <nz-col nzSpan="24">
                              <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                                [(ngModel)]="class['frame-banner__slick-dot__label']['font-weight']"
                                (nzOnAfterChange)="updateClass()">
                              </nz-slider>
                            </nz-col>
                          </nz-row>
                        </div>
                        <!-- Canh lề -->
                        <div class="config-font">
                          <p class="title">{{'canh_le' | translate}}</p>
                          <div class="config-name">
                            <button class="font-text-btn" nz-button
                              [nzType]="
                                class['frame-banner__slick-dot__label']['right'] == 'auto'
                                  && class['frame-banner__slick-dot__label']['transform'] == 'translateX(0)'
                                    ? 'primary'
                                    : 'default'"
                              (click)="handleSetNumberTextContent('left')">
                              <i nz-icon nzType="align-left" nzTheme="outline"></i>
                            </button>
                            <button class="font-text-btn" nz-button 
                              [nzType]="
                                class['frame-banner__slick-dot__label']['left'] == '50%'
                                  ? 'primary'
                                  : 'default'"
                              (click)="handleSetNumberTextContent('center')">
                              <i nz-icon nzType="align-center" nzTheme="outline"></i>
                            </button>
                            <button class="font-text-btn" nz-button 
                              [nzType]="
                                class['frame-banner__slick-dot__label']['left'] == 'auto'
                                  ? 'primary'
                                  : 'default'"
                              (click)="handleSetNumberTextContent('right')">
                              <i nz-icon nzType="align-right" nzTheme="outline"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="field-row">
                      <div class="config-font" style="margin-top:20px">
                        <!-- Khoảng cách chữ -->
                        <div>
                          <div class="config-name mb-0">
                            <p>{{ 'khoang_cach_chu' | translate }}</p>
                            <nz-input-number [nzMin]="0" [nzMax]="50"
                              [ngModel]="class['frame-banner__slick-dot__label']['letter-spacing'] | vhnumber"
                              (ngModelChange)="class['frame-banner__slick-dot__label']['letter-spacing'] = $event+'px'"
                              (nzBlur)="updateClass()">
                            </nz-input-number>
                          </div>
                          <nz-row>
                            <nz-col nzSpan="24">
                              <nz-slider [nzMin]="0" [nzMax]="50"
                                [ngModel]="class['frame-banner__slick-dot__label']['letter-spacing'] | vhnumber"
                                (ngModelChange)="class['frame-banner__slick-dot__label']['letter-spacing'] = $event+'px'"
                                (nzOnAfterChange)="updateClass()">
                              </nz-slider>
                            </nz-col>
                          </nz-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
            <div nz-submenu nzTitle="{{'thiet_lap_nhan_slide_duoc_chon' | translate}}" [(nzOpen)]="openMenu.menu14">
              <div class="editor-field mb-0">
                <!-- Kiểu nút slide -->
                <div class="config-row mt-2">
                  <p class="mb-3">{{'che_do_nhan_active' | translate}}</p>
                  <nz-radio-group [ngModel]="config['slick_dot_label']['active_mode']"
                  (ngModelChange)="config['slick_dot_label']['active_mode'] = $event; updateConfig()">
                    <label nz-radio nzValue="none">{{'khong_hien_thi' | translate}}</label>
                    <label nz-radio nzValue="always">{{'luon_hien_thi' | translate}}</label>
                    <label nz-radio nzValue="timed">{{'hien_thi_sau_do_an_di' | translate}}</label>
                  </nz-radio-group>
                </div>

                <!-- Màu nền -->
                <div class="config-name">
                  <p>{{'mau_nen' | translate}}</p>
                  <input class="input-color" style="width:22%;"  type="button"
                    [style.background]="class['frame-banner__slick-dot__label--active']['background-color']"
                    [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot__label--active']['background-color']"
                    (colorPickerClose)="updateClass()" />
                </div>

                <!-- Vị trí nhãn khi di chuột -->
                <div *ngIf="device == 'desktop'">
                  <div class="config-name">
                    <p>{{'vi_tri_nhan_khi_di_chuot' | translate}}</p>
                    <nz-input-number [nzMin]="-200" [nzMax]="200" style="width: 30%"
                      [ngModel]="config['slick_dot_label']['hover_label_active_translateX'] | vhnumber"
                      (ngModelChange)="config['slick_dot_label']['hover_label_active_translateX'] = $event +'px'"
                      (nzBlur)="updateConfig()">
                    </nz-input-number>
                  </div>
                  <nz-slider [nzMin]="-200" [nzMax]="200" [nzStep]="1"
                    [ngModel]="config['slick_dot_label']['hover_label_active_translateX'] | vhnumber"
                    (ngModelChange)="config['slick_dot_label']['hover_label_active_translateX'] = $event+'px'"
                    (nzOnAfterChange)="updateConfig()">
                  </nz-slider>
                </div>

                <ul nz-menu nzMode="inline">
                  <div nz-submenu nzTitle="{{'kich_thuoc_nhan' | translate}}">
                    <!-- Chiều rộng -->
                    <div>
                      <div class="config-name">
                        <p>{{'chieu_rong' | translate}}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="300"
                          [ngModel]="class['frame-banner__slick-dot__label--active']['width'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot__label--active']['width'] = $event +'px'"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-slider [nzMin]="0" [nzMax]="300" [nzStep]="1"
                        [ngModel]="class['frame-banner__slick-dot__label--active']['width'] | vhnumber"
                        (ngModelChange)="class['frame-banner__slick-dot__label--active']['width'] = $event+'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </div>
                    <!-- Chiều cao -->
                    <div>
                      <div class="config-name">
                        <p>{{'chieu_cao' | translate}}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="300"
                          [ngModel]="class['frame-banner__slick-dot__label--active']['height'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot__label--active']['height'] = $event +'px'"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-slider [nzMin]="0" [nzMax]="300" [nzStep]="1"
                        [ngModel]="class['frame-banner__slick-dot__label--active']['height'] | vhnumber"
                        (ngModelChange)="class['frame-banner__slick-dot__label--active']['height'] = $event+'px'"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </div>
                  </div>
                  <div nz-submenu nzTitle="{{'vien' | translate}}">
                    <app-borders-config
                      [elementChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [borderClass]="class['frame-banner__slick-dot__label--active']"
                      [id_object]="objectChoosing._id"
                    >
                    </app-borders-config>
                    <!-- Bo góc -->
                    <app-borders-radius-config
                      [elementChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [borderRadiusClass]="class['frame-banner__slick-dot__label--active']"
                      [id_object]="objectChoosing._id"
                    >
                    </app-borders-radius-config>
                  </div>
                  <div nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}">
                    <div class="field-row mt-0">
                      <div class="config-font-size">
                        <!-- Font Family -->
                        <div class="field-row-font" style="width:65%">
                          <mat-form-field style="width:100%">
                            <mat-label>Font</mat-label>
                            <mat-select
                              [(ngModel)]="class['frame-banner__slick-dot__label--active']['font-family']"
                              (ngModelChange)="updateClass()">
                              <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- Font size -->
                        <div class="field-row-size" style="width:35%;padding-right:5px">
                          <mat-form-field style="width:100%">
                            <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                            <input matInput type="number" min="1" max="200"
                              [ngModel]="class['frame-banner__slick-dot__label--active']['font-size'] | vhnumber"
                              (ngModelChange)="class['frame-banner__slick-dot__label--active']['font-size'] = $event+'px'"
                              (blur)="updateClass()">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                    <div class="field-row">
                      <div class="config-font">
                        <p class="title">{{'kieu_chu' | translate}}</p>
                        <div class="config-name">
                          <!-- In đậm -->
                          <button class="font-text-btn" title="Bold" nz-button [nzType]="
                            class['frame-banner__slick-dot__label--active']['font-weight'] >= 700
                              ? 'primary'
                              : 'default'
                            "(click)="
                              class['frame-banner__slick-dot__label--active']['font-weight'] =
                                class['frame-banner__slick-dot__label--active']['font-weight'] >= 700
                                  ? '400'
                                  : '700'
                            "(click)="updateClass();">
                            <span style="font-weight:600;">B</span>
                          </button>
                          <!-- In nghiêng -->
                          <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                            class['frame-banner__slick-dot__label--active']['font-style'] == 'italic'
                              ? 'primary'
                              : 'default'
                            "(click)="
                              class['frame-banner__slick-dot__label--active']['font-style'] =
                                class['frame-banner__slick-dot__label--active']['font-style'] == 'normal'
                                  ? 'italic'
                                  : 'normal'
                            "(click)="updateClass();">
                            <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                          </button>
                          <!-- Gạch dưới -->
                          <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                            class['frame-banner__slick-dot__label--active']['text-decoration'] == 'underline'
                              ? 'primary'
                              : 'default'
                            "(click)="
                              class['frame-banner__slick-dot__label--active']['text-decoration'] =
                                class['frame-banner__slick-dot__label--active']['text-decoration'] == 'none'
                                  ? 'underline'
                                  : 'none'
                            "(click)="updateClass();">
                            <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                          </button>
                          <!-- Màu chữ -->
                          <input class="input-color" style="width:22%;"  type="button"
                            [style.background]="class['frame-banner__slick-dot__label--active']['color']"
                            [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot__label--active']['color']"
                            (colorPickerClose)="updateClass()" />
                        </div>
                        <!-- Độ đậm -->
                        <div class="my-3 mt-4">
                          <div class="config-name mb-0">
                            <p>{{'do_dam' | translate}}</p>
                            <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                              [(ngModel)]="class['frame-banner__slick-dot__label--active']['font-weight']"
                              (nzBlur)="updateClass()">
                            </nz-input-number>
                          </div>
                          <nz-row>
                            <nz-col nzSpan="24">
                              <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                                [(ngModel)]="class['frame-banner__slick-dot__label--active']['font-weight']"
                                (nzOnAfterChange)="updateClass()">
                              </nz-slider>
                            </nz-col>
                          </nz-row>
                        </div>
                        <!-- Canh lề -->
                        <div class="config-font">
                          <p class="title">{{'canh_le' | translate}}</p>
                          <div class="config-name">
                            <button class="font-text-btn" nz-button
                              [nzType]="
                                class['frame-banner__slick-dot__label--active']['right'] == 'auto'
                                  && class['frame-banner__slick-dot__label--active']['transform'] == 'translateX(0)'
                                    ? 'primary'
                                    : 'default'"
                              (click)="handleSetNumberTextContent('left')">
                              <i nz-icon nzType="align-left" nzTheme="outline"></i>
                            </button>
                            <button class="font-text-btn" nz-button 
                              [nzType]="
                                class['frame-banner__slick-dot__label--active']['left'] == '50%'
                                  ? 'primary'
                                  : 'default'"
                              (click)="handleSetNumberTextContent('center')">
                              <i nz-icon nzType="align-center" nzTheme="outline"></i>
                            </button>
                            <button class="font-text-btn" nz-button 
                              [nzType]="
                                class['frame-banner__slick-dot__label--active']['left'] == 'auto'
                                  ? 'primary'
                                  : 'default'"
                              (click)="handleSetNumberTextContent('right')">
                              <i nz-icon nzType="align-right" nzTheme="outline"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="field-row">
                      <div class="config-font" style="margin-top:20px">
                        <!-- Khoảng cách chữ -->
                        <div>
                          <div class="config-name mb-0">
                            <p>{{ 'khoang_cach_chu' | translate }}</p>
                            <nz-input-number [nzMin]="0" [nzMax]="50"
                              [ngModel]="class['frame-banner__slick-dot__label--active']['letter-spacing'] | vhnumber"
                              (ngModelChange)="class['frame-banner__slick-dot__label--active']['letter-spacing'] = $event+'px'"
                              (nzBlur)="updateClass()">
                            </nz-input-number>
                          </div>
                          <nz-row>
                            <nz-col nzSpan="24">
                              <nz-slider [nzMin]="0" [nzMax]="50"
                                [ngModel]="class['frame-banner__slick-dot__label--active']['letter-spacing'] | vhnumber"
                                (ngModelChange)="class['frame-banner__slick-dot__label--active']['letter-spacing'] = $event+'px'"
                                (nzOnAfterChange)="updateClass()">
                              </nz-slider>
                            </nz-col>
                          </nz-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
          </ng-container>
          <!-- Thiết lập nút chưa chọn -->
          <div nz-submenu [nzTitle]="'thiet_lap_nut_chua_chon' | translate" [(nzOpen)]="openMenu.menu10">
            <div class="editor-field">
              <!-- Kích thước nút (chiều rộng) -->
              <div>
                <div class="config-name mt-0">
                  <p>{{'kich_thuoc_nut' | translate}} <span *ngIf="config['slick-dots']['background_style'] == 'rectangle'"> ({{'chieu_rong' | translate}})</span></p>
                  <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot']['width'] | vhnumber"
                    (ngModelChange)="handleSetDotsSize($event, '')"
                    (nzBlur)="updateConfig(); updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot']['width'] | vhnumber"
                    (ngModelChange)="handleSetDotsSize($event, '')"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                </nz-slider>
              </div>
              <!-- Kích thước nút (chiều cao) -->
              <div *ngIf="config['slick-dots']['background_style'] == 'rectangle'">
                <div class="config-name">
                  <p>{{'kich_thuoc_nut_(_chieu_cao_)' | translate}} </p>
                  <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot']['height'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot']['height'] = $event+'px';"
                    (nzBlur)="updateConfig(); updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot']['height'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot']['height'] = $event+'px';"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                </nz-slider>
              </div>
              <!-- Màu nền -->
              <div class="config-name">
                <p>{{'mau_nen' | translate}} </p>
                <input class="input-color"  type="button"
                  [style.background]="class['frame-banner__slick-dot']['background-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
              <!-- Màu viền -->
              <div class="config-name">
                <p>{{'mau_vien' | translate}} </p>
                <input class="input-color"  type="button"
                  [style.background]="class['frame-banner__slick-dot']['border-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot']['border-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
              <!-- Độ dày viền -->
              <div>
                <div class="config-name">
                  <p>{{'do_day_vien' | translate}} </p>
                  <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="0.5"
                    [ngModel]="class['frame-banner__slick-dot']['border-width'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot']['border-width'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="0.5"
                    [ngModel]="class['frame-banner__slick-dot']['border-width'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot']['border-width'] = $event+'px'"
                    (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <div *ngIf="config['frame-banner']['is_slide_number']">
                <div class="field-row mt-0">
                  <div class="config-font-size">
                    <!-- Font Family -->
                    <div class="field-row-font" style="width:65%">
                      <mat-form-field style="width:100%">
                        <mat-label>Font</mat-label>
                        <mat-select
                          [(ngModel)]="class['frame-banner__slick-dot']['font-family']"
                          (ngModelChange)="updateClass()">
                          <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <!-- Font size -->
                    <div class="field-row-size" style="width:35%;padding-right:5px">
                      <mat-form-field style="width:100%">
                        <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                        <input matInput type="number" min="1" max="200"
                          [ngModel]="class['frame-banner__slick-dot']['font-size'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot']['font-size'] = $event+'px'"
                          (blur)="updateClass()">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="field-row">
                  <div class="config-font">
                    <p class="title">{{'kieu_chu' | translate}}</p>
                    <div class="config-name">
                      <!-- In đậm -->
                      <button class="font-text-btn" title="Bold" nz-button [nzType]="
                        class['frame-banner__slick-dot']['font-weight'] >= 700
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__slick-dot']['font-weight'] =
                            class['frame-banner__slick-dot']['font-weight'] >= 700
                              ? '400'
                              : '700'
                        "(click)="updateClass();">
                        <span style="font-weight:600;">B</span>
                      </button>
                      <!-- In nghiêng -->
                      <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class['frame-banner__slick-dot']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__slick-dot']['font-style'] =
                            class['frame-banner__slick-dot']['font-style'] == 'normal'
                              ? 'italic'
                              : 'normal'
                        "(click)="updateClass();">
                        <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Gạch dưới -->
                      <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class['frame-banner__slick-dot']['text-decoration'] == 'underline'
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__slick-dot']['text-decoration'] =
                            class['frame-banner__slick-dot']['text-decoration'] == 'none'
                              ? 'underline'
                              : 'none'
                        "(click)="updateClass();">
                        <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Màu chữ -->
                      <input class="input-color" style="width:22%;"  type="button"
                        [style.background]="class['frame-banner__slick-dot']['color']"
                        [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot']['color']"
                        (colorPickerClose)="updateClass()" />
                    </div>
                    <!-- Độ đậm -->
                    <div class="my-3 mt-4">
                      <div class="config-name mb-0">
                        <p>{{'do_dam' | translate}}</p>
                        <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                          [(ngModel)]="class['frame-banner__slick-dot']['font-weight']"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-row>
                        <nz-col nzSpan="24">
                          <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                            [(ngModel)]="class['frame-banner__slick-dot']['font-weight']"
                            (nzOnAfterChange)="updateClass()">
                          </nz-slider>
                        </nz-col>
                      </nz-row>
                    </div>
                    <!-- Canh lề -->
                    <div class="config-font">
                      <p class="title">{{'canh_le' | translate}}</p>
                      <div class="config-name">
                        <button class="font-text-btn" nz-button
                          [nzType]="
                            class['frame-banner__slick-dot']['right'] == 'auto'
                              && class['frame-banner__slick-dot']['transform'] == 'translateX(0)'
                                ? 'primary'
                                : 'default'"
                          (click)="handleSetNumberTextContent('left')">
                          <i nz-icon nzType="align-left" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button 
                          [nzType]="
                            class['frame-banner__slick-dot']['left'] == '50%'
                              ? 'primary'
                              : 'default'"
                          (click)="handleSetNumberTextContent('center')">
                          <i nz-icon nzType="align-center" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button 
                          [nzType]="
                            class['frame-banner__slick-dot']['left'] == 'auto'
                              ? 'primary'
                              : 'default'"
                          (click)="handleSetNumberTextContent('right')">
                          <i nz-icon nzType="align-right" nzTheme="outline"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field-row">
                  <div class="config-font" style="margin-top:20px">
                    <!-- Khoảng cách chữ -->
                    <div>
                      <div class="config-name mb-0">
                        <p>{{ 'khoang_cach_chu' | translate }}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="50"
                          [ngModel]="class['frame-banner__slick-dot']['letter-spacing'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot']['letter-spacing'] = $event+'px'"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-row>
                        <nz-col nzSpan="24">
                          <nz-slider [nzMin]="0" [nzMax]="50"
                            [ngModel]="class['frame-banner__slick-dot']['letter-spacing'] | vhnumber"
                            (ngModelChange)="class['frame-banner__slick-dot']['letter-spacing'] = $event+'px'"
                            (nzOnAfterChange)="updateClass()">
                          </nz-slider>
                        </nz-col>
                      </nz-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Thiết lập nút được chọn -->
          <div nz-submenu [nzTitle]="'thiet_lap_nut_duoc_chon' | translate" [(nzOpen)]="openMenu.menu11">
            <div class="editor-field">
              <!-- Kích thước nút (chiều rộng) -->
              <div>
                <div class="config-name mt-0">
                  <p>{{'kich_thuoc_nut' | translate}} <span *ngIf="config['slick-dots']['background_style'] == 'rectangle'"> ({{'chieu_rong' | translate}})</span></p>
                  <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot--active']['width'] | vhnumber"
                    (ngModelChange)="handleSetDotsSize($event, 'active')"
                    (nzBlur)="updateConfig(); updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot--active']['width'] | vhnumber"
                    (ngModelChange)="handleSetDotsSize($event, 'active')"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                </nz-slider>
              </div>
              <!-- Kích thước nút (chiều cao) -->
              <div *ngIf="config['slick-dots']['background_style'] == 'rectangle'">
                <div class="config-name">
                  <p>{{'kich_thuoc_nut_(_chieu_cao_)' | translate}} </p>
                  <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot--active']['height'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot--active']['height'] = $event+'px';"
                    (nzBlur)="updateConfig(); updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
                    [ngModel]="class['frame-banner__slick-dot--active']['height'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot--active']['height'] = $event+'px';"
                    (nzOnAfterChange)="updateConfig(); updateClass()">
                </nz-slider>
              </div>
              <!-- Màu nền -->
              <div class="config-name">
                <p>{{'mau_nen' | translate}} </p>
                <input class="input-color"  type="button"
                  [style.background]="class['frame-banner__slick-dot--active']['background-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot--active']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
              <!-- Màu viền -->
              <div class="config-name">
                <p>{{'mau_vien' | translate}} </p>
                <input class="input-color"  type="button"
                  [style.background]="class['frame-banner__slick-dot--active']['border-color']"
                  [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot--active']['border-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
              <!-- Độ dày viền -->
              <div>
                <div class="config-name">
                  <p>{{'do_day_vien' | translate}} </p>
                  <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="0.5"
                    [ngModel]="class['frame-banner__slick-dot--active']['border-width'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot--active']['border-width'] = $event +'px'"
                    (nzBlur)="updateClass()">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="0.5"
                    [ngModel]="class['frame-banner__slick-dot--active']['border-width'] | vhnumber"
                    (ngModelChange)="class['frame-banner__slick-dot--active']['border-width'] = $event+'px'"
                    (nzOnAfterChange)="updateClass()">
                </nz-slider>
              </div>
              <div *ngIf="config['frame-banner']['is_slide_number']">
                <div class="field-row mt-0">
                  <div class="config-font-size">
                    <!-- Font Family -->
                    <div class="field-row-font" style="width:65%">
                      <mat-form-field style="width:100%">
                        <mat-label>Font</mat-label>
                        <mat-select
                          [(ngModel)]="class['frame-banner__slick-dot--active']['font-family']"
                          (ngModelChange)="updateClass()">
                          <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <!-- Font size -->
                    <div class="field-row-size" style="width:35%;padding-right:5px">
                      <mat-form-field style="width:100%">
                        <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                        <input matInput type="number" min="1" max="200"
                          [ngModel]="class['frame-banner__slick-dot--active']['font-size'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot--active']['font-size'] = $event+'px'"
                          (blur)="updateClass()">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="field-row">
                  <div class="config-font">
                    <p class="title">{{'kieu_chu' | translate}}</p>
                    <div class="config-name">
                      <!-- In đậm -->
                      <button class="font-text-btn" title="Bold" nz-button [nzType]="
                        class['frame-banner__slick-dot--active']['font-weight'] >= 700
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__slick-dot--active']['font-weight'] =
                            class['frame-banner__slick-dot--active']['font-weight'] >= 700
                              ? '400'
                              : '700'
                        "(click)="updateClass();">
                        <span style="font-weight:600;">B</span>
                      </button>
                      <!-- In nghiêng -->
                      <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                        class['frame-banner__slick-dot--active']['font-style'] == 'italic'
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__slick-dot--active']['font-style'] =
                            class['frame-banner__slick-dot--active']['font-style'] == 'normal'
                              ? 'italic'
                              : 'normal'
                        "(click)="updateClass();">
                        <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Gạch dưới -->
                      <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                        class['frame-banner__slick-dot--active']['text-decoration'] == 'underline'
                          ? 'primary'
                          : 'default'
                        "(click)="
                          class['frame-banner__slick-dot--active']['text-decoration'] =
                            class['frame-banner__slick-dot--active']['text-decoration'] == 'none'
                              ? 'underline'
                              : 'none'
                        "(click)="updateClass();">
                        <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                      </button>
                      <!-- Màu chữ -->
                      <input class="input-color" style="width:22%;"  type="button"
                        [style.background]="class['frame-banner__slick-dot--active']['color']"
                        [cpOKButton]="true" [(colorPicker)]="class['frame-banner__slick-dot--active']['color']"
                        (colorPickerClose)="updateClass()" />
                    </div>
                    <!-- Độ đậm -->
                    <div class="my-3 mt-4">
                      <div class="config-name mb-0">
                        <p>{{'do_dam' | translate}}</p>
                        <nz-input-number [nzMin]="100" [nzMax]="900" [nzStep]="100"
                          [(ngModel)]="class['frame-banner__slick-dot--active']['font-weight']"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-row>
                        <nz-col nzSpan="24">
                          <nz-slider [nzMin]="100" [nzMax]="900" [nzStep]="100"
                            [(ngModel)]="class['frame-banner__slick-dot--active']['font-weight']"
                            (nzOnAfterChange)="updateClass()">
                          </nz-slider>
                        </nz-col>
                      </nz-row>
                    </div>
                    <!-- Canh lề -->
                    <div class="config-font">
                      <p class="title">{{'canh_le' | translate}}</p>
                      <div class="config-name">
                        <button class="font-text-btn" nz-button
                          [nzType]="
                            class['frame-banner__slick-dot--active']['right'] == 'auto'
                              && class['frame-banner__slick-dot--active']['transform'] == 'translateX(0)'
                                ? 'primary'
                                : 'default'"
                          (click)="handleSetNumberTextContent('left')">
                          <i nz-icon nzType="align-left" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button 
                          [nzType]="
                            class['frame-banner__slick-dot--active']['left'] == '50%'
                              ? 'primary'
                              : 'default'"
                          (click)="handleSetNumberTextContent('center')">
                          <i nz-icon nzType="align-center" nzTheme="outline"></i>
                        </button>
                        <button class="font-text-btn" nz-button 
                          [nzType]="
                            class['frame-banner__slick-dot--active']['left'] == 'auto'
                              ? 'primary'
                              : 'default'"
                          (click)="handleSetNumberTextContent('right')">
                          <i nz-icon nzType="align-right" nzTheme="outline"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field-row">
                  <div class="config-font" style="margin-top:20px">
                    <!-- Khoảng cách chữ -->
                    <div>
                      <div class="config-name mb-0">
                        <p>{{ 'khoang_cach_chu' | translate }}</p>
                        <nz-input-number [nzMin]="0" [nzMax]="50"
                          [ngModel]="class['frame-banner__slick-dot--active']['letter-spacing'] | vhnumber"
                          (ngModelChange)="class['frame-banner__slick-dot--active']['letter-spacing'] = $event+'px'"
                          (nzBlur)="updateClass()">
                        </nz-input-number>
                      </div>
                      <nz-row>
                        <nz-col nzSpan="24">
                          <nz-slider [nzMin]="0" [nzMax]="50"
                            [ngModel]="class['frame-banner__slick-dot--active']['letter-spacing'] | vhnumber"
                            (ngModelChange)="class['frame-banner__slick-dot--active']['letter-spacing'] = $event+'px'"
                            (nzOnAfterChange)="updateClass()">
                          </nz-slider>
                        </nz-col>
                      </nz-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMenu.menu3" (nzOpenChange)="openHandler('menu3')">
        <!-- Lựa chọn hiển thị cho các thiết bị -->
        <div class="editor-field">
          <app-hide-show-config
                    [device]="device"
                    [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- Xem chi tiết cấu hình frame -->
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['frame-banner']"
                    [id_object]="objectChoosing._id"
                    [elementChoosing]="objectChoosing"
      >
      </app-borders-radius-config>
    </div>
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config
                    [device]="device"
                    [class]="class"
                    [borderRadiusClass]="class['frame-banner__slick-dot']"
                    [id_object]="objectChoosing._id"
                    [elementChoosing]="objectChoosing"
      >
      </app-borders-radius-config>
      
    </div>
    <!-- Cấu hình chi tiết nút Prev -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <!-- Kiểu nền -->
      <div class="field-row"
        *ngIf="config['frame-banner__btn--prev']['background_check']
            || config['frame-banner__btn--prev']['border_check']
            || config['frame-banner__btn--prev']['is_box_shadow']">
        <p>{{'kieu_nen' | translate}} </p>
        <nz-radio-group
          [(ngModel)]="config['frame-banner__btn--prev']['background_style']"
          (ngModelChange)="handleSetButtonStyle($event, 'prev')">
          <label nz-radio nzValue="circle">{{'hinh_tron' | translate}}</label>
          <label nz-radio nzValue="square">{{'hinh_vuong' | translate}}</label>
          <label nz-radio nzValue="rectangle">{{'hinh_chu_nhat' | translate}}</label>
        </nz-radio-group>
        <!-- Kích thước nút (chiều rộng) -->
        <div>
          <div class="config-name">
            <p>{{'kich_thuoc_nut' | translate}} <span *ngIf="config['frame-banner__btn--prev']['background_style'] == 'rectangle'"> (chiều rộng)</span></p>
            <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--prev']['width'] | vhnumber"
              (ngModelChange)="handleSetButtonSize($event, 'prev')"
              (nzBlur)="updateConfig(); updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--prev']['width'] | vhnumber"
              (ngModelChange)="handleSetButtonSize($event, 'prev')"
              (nzOnAfterChange)="updateConfig(); updateClass()">
          </nz-slider>
        </div>
        <!-- Kích thước nút (chiều cao) -->
        <div *ngIf="config['frame-banner__btn--prev']['background_style'] == 'rectangle'">
          <div class="config-name">
            <p>{{'kich_thuoc_nut_(_chieu_cao_)' | translate}} </p>
            <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--prev']['height'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--prev']['height'] = $event+'px';"
              (nzBlur)="updateConfig(); updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--prev']['height'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--prev']['height'] = $event+'px';"
              (nzOnAfterChange)="updateConfig(); updateClass()">
          </nz-slider>
        </div>
        <!-- Bo góc -->
        <div *ngIf="config['frame-banner__btn--prev']['background_style'] != 'circle'">
          <div class="config-name">
            <p>{{'bo_goc' | translate}}</p>
            <nz-input-number [nzMin]="0" [nzMax]="50"
              [ngModel]="class['frame-banner__btn--prev']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--prev']['border-radius'] = $event +'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
            [ngModel]="class['frame-banner__btn--prev']['border-radius'] | vhnumber"
            (nzOnAfterChange)="updateClass()"
            (ngModelChange)="class['frame-banner__btn--prev']['border-radius'] = $event+'px';">
          </nz-slider>
        </div>
        <hr style="border-top: 1px solid rgb(223 223 223)" />
      </div>
      <!-- Màu nền -->
      <div class="field-row">
        <div class="config-name">
          <p>{{'to_mau_nen' | translate}} </p>
          <nz-switch [(ngModel)]="config['frame-banner__btn--prev']['background_check']"
            (ngModelChange)="handleSetButtonBackground('prev')">
          </nz-switch>
        </div>
        <div class="field-row" *ngIf="config['frame-banner__btn--prev']['background_check']">
          <!-- Màu nền -->
          <div class="field-row">
            <div class="config-name">
              <p>{{'mau_nen' | translate}} </p>
              <input class="input-color"  type="button"
                [style.background]="class['frame-banner__btn--prev']['background-color']"
                [cpOKButton]="true" [(colorPicker)]="class['frame-banner__btn--prev']['background-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <hr style="border-top: 1px solid rgb(223 223 223)" />
        </div>
      </div>
      <!-- Viền -->
      <div class="field-row">
        <div class="config-name">
          <p>{{'co_vien' | translate}} </p>
          <nz-switch [(ngModel)]="config['frame-banner__btn--prev']['border_check']"
            (ngModelChange)="handleSetButtonBorder('prev')">
          </nz-switch>
        </div>
        <div class="field-row" *ngIf="config['frame-banner__btn--prev']['border_check']">
          <!-- Màu viền -->
          <div class="field-row">
            <div class="config-name">
              <p>{{'mau_vien' | translate}} </p>
              <input class="input-color"  type="button"
                [style.background]="class['frame-banner__btn--prev']['border-color']"
                [cpOKButton]="true" [(colorPicker)]="class['frame-banner__btn--prev']['border-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Kích thước viền -->
          <div class="config-name">
            <p>{{'kich_thuoc_vien' | translate}} </p>
            <nz-input-number [nzMin]="0" [nzMax]="10"
              [ngModel]="class['frame-banner__btn--prev']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--prev']['border-width'] = $event +'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <hr style="border-top: 1px solid rgb(223 223 223)" />
        </div>
      </div>
      <!-- Đổ bóng -->
      <app-shadow-config 
          [device]="device"
          [config]="config"
          [class]="class"
          [shadowClass]="class['frame-banner__btn--prev']"
          [shadowConfig]="config['frame-banner__btn--prev']"
          [objectChoosing]="objectChoosing"
          >
      </app-shadow-config>
    </div>
    <!-- Cấu hình chi tiết nút Next -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <!-- Kiểu nền -->
      <div class="field-row"
        *ngIf="config['frame-banner__btn--next']['background_check']
            || config['frame-banner__btn--next']['border_check']
            || config['frame-banner__btn--next']['is_box_shadow']">
        <p>{{'kieu_nen' | translate}} </p>
        <nz-radio-group
          [(ngModel)]="config['frame-banner__btn--next']['background_style']"
          (ngModelChange)="handleSetButtonStyle($event, 'next')">
          <label nz-radio nzValue="circle">{{'hinh_tron' | translate}}</label>
          <label nz-radio nzValue="square">{{'hinh_vuong' | translate}}</label>
          <label nz-radio nzValue="rectangle">{{'hinh_chu_nhat' | translate}}</label>
        </nz-radio-group>
        <!-- Kích thước nút (chiều rộng) -->
        <div>
          <div class="config-name">
            <p>{{'kich_thuoc_nut' | translate}} <span *ngIf="config['frame-banner__btn--next']['background_style'] == 'rectangle'"> (chiều rộng)</span></p>
            <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--next']['width'] | vhnumber"
              (ngModelChange)="handleSetButtonSize($event, 'next')"
              (nzBlur)="updateConfig(); updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--next']['width'] | vhnumber"
              (ngModelChange)="handleSetButtonSize($event, 'next')"
              (nzOnAfterChange)="updateConfig(); updateClass()">
          </nz-slider>
        </div>
        <!-- Kích thước nút (chiều cao) -->
        <div *ngIf="config['frame-banner__btn--next']['background_style'] == 'rectangle'">
          <div class="config-name">
            <p>{{'kich_thuoc_nut_(_chieu_cao_)' | translate}} </p>
            <nz-input-number [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--next']['height'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--next']['height'] = $event+'px';"
              (nzBlur)="updateConfig(); updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="80" [nzStep]="1"
              [ngModel]="class['frame-banner__btn--next']['height'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--next']['height'] = $event+'px';"
              (nzOnAfterChange)="updateConfig(); updateClass()">
          </nz-slider>
        </div>
        <!-- Bo góc -->
        <div *ngIf="config['frame-banner__btn--next']['background_style'] != 'circle'">
          <div class="config-name">
            <p>{{'bo_goc' | translate}}</p>
            <nz-input-number [nzMin]="0" [nzMax]="50"
              [ngModel]="class['frame-banner__btn--next']['border-radius'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--next']['border-radius'] = $event +'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="1"
            [ngModel]="class['frame-banner__btn--next']['border-radius'] | vhnumber"
            (ngModelChange)="class['frame-banner__btn--next']['border-radius'] = $event+'px';"
            (nzOnAfterChange)="updateClass()">
          </nz-slider>
        </div>
        <hr style="border-top: 1px solid rgb(223 223 223)" />
      </div>
      <!-- Màu nền -->
      <div class="field-row">
        <div class="config-name">
          <p>{{'to_mau_nen' | translate}} </p>
          <nz-switch [(ngModel)]="config['frame-banner__btn--next']['background_check']"
            (ngModelChange)="handleSetButtonBackground('next')">
          </nz-switch>
        </div>
        <div class="field-row" *ngIf="config['frame-banner__btn--next']['background_check']">
          <!-- Màu nền -->
          <div class="field-row">
            <div class="config-name">
              <p>{{'mau_nen' | translate}} </p>
              <input class="input-color"  type="button"
                [style.background]="class['frame-banner__btn--next']['background-color']"
                [cpOKButton]="true" [(colorPicker)]="class['frame-banner__btn--next']['background-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <hr style="border-top: 1px solid rgb(223 223 223)" />
        </div>
      </div>
      <!-- Viền -->
      <div class="field-row">
        <div class="config-name">
          <p>{{'co_vien' | translate}} </p>
          <nz-switch [(ngModel)]="config['frame-banner__btn--next']['border_check']"
            (ngModelChange)="handleSetButtonBorder('next')">
          </nz-switch>
        </div>
        <div class="field-row" *ngIf="config['frame-banner__btn--next']['border_check']">
          <!-- Màu viền -->
          <div class="field-row">
            <div class="config-name">
              <p>{{'mau_vien' | translate}} </p>
              <input class="input-color"  type="button"
                [style.background]="class['frame-banner__btn--next']['border-color']"
                [cpOKButton]="true" [(colorPicker)]="class['frame-banner__btn--next']['border-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </div>
          <!-- Kích thước viền -->
          <div class="config-name">
            <p>{{'kich_thuoc_vien' | translate}} </p>
            <nz-input-number [nzMin]="0" [nzMax]="10"
              [ngModel]="class['frame-banner__btn--next']['border-width'] | vhnumber"
              (ngModelChange)="class['frame-banner__btn--next']['border-width'] = $event +'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <hr style="border-top: 1px solid rgb(223 223 223)" />
        </div>
      </div>
      <!-- Đổ bóng -->
      <app-shadow-config 
          [device]="device"
          [config]="config"
          [class]="class"
          [shadowClass]="class['frame-banner__btn--next']"
          [shadowConfig]="config['frame-banner__btn--next']"
          [objectChoosing]="objectChoosing"
          >
      </app-shadow-config>
    </div>
  </div>
</div>
